import { render, staticRenderFns } from "./r-league-config-page.vue?vue&type=template&id=75489bb0"
import script from "./r-league-config-page.vue?vue&type=script&lang=js"
export * from "./r-league-config-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75489bb0')) {
      api.createRecord('75489bb0', component.options)
    } else {
      api.reload('75489bb0', component.options)
    }
    module.hot.accept("./r-league-config-page.vue?vue&type=template&id=75489bb0", function () {
      api.rerender('75489bb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/server-events/leaderboard/r-league-config-page.vue"
export default component.exports